import { READY_REMIT_ACTIONS } from "../constants/actionTypes";
import { RRVirtualSenderAlias } from "../types/api/readyremit";

/**
 * Update pages to override what is set by api response
 */
export function SetRRAuth(payload: { rsp: string, transferMethod: string, encryptedAuthToken: string, senderId: string, balanceCheck: RRVirtualSenderAlias }) {
  return {
    type: READY_REMIT_ACTIONS.SET_AUTH,
    payload
  };
}